var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.batteryStatus !== null && _vm.params.batteryStatus !== -1)?_c('img',{staticClass:"battery",attrs:{"src":_vm.icon,"title":_vm.description}}):_c('span',{attrs:{"title":_vm.$t('battery-not-seen-message')}},[_vm._v("-- --")])])
}
var staticRenderFns = []

export { render, staticRenderFns }